import { Identifier, Record, Version, DocumentRecord, DocumentRecordData, DatabaseType } from '../../offline-first';
import { Workout, PlannedTier, PlannedTierRow } from './plan-document';
import moment from 'moment';

export interface UserLibrary extends Record {
  id: Identifier;
  type: 'UserLibrary';
  version: Version;
  exercise_program_id: Identifier;
  exercise_program_version: Version;
  user: User;
  workouts: Template[];
  tiers: Template[];
  rows: Template[];
}

export interface User {
  uuid: string;
  first_name?: string;
  last_name?: string;
  rank?: string;
  email: string;
}

export interface Template {
  id: string;
  name: string;
  template: Workout | PlannedTier | PlannedTierRow;
}

export class UserLibraryDocument extends DocumentRecord<UserLibrary> {
  static recordName = 'UserLibraryDocument';
  static objectStoreName = 'userLibraryDocuments';

  constructor(data?: DocumentRecordData<UserLibrary>) {
    super(data);
  }
}

export class UserLibraryDocumentCache extends UserLibraryDocument {
  static recordName = 'UserLibraryDocumentCache';
  static objectStoreName = 'userLibraryDocumentsCache';
  static fields = ['version', 'userUUID', 'document', 'lastSynced'];

  static databaseType = DatabaseType.Document;

  syncedAt: moment.Moment;

  constructor(lib: UserLibraryDocument) {
    super({ key: lib.key, document: lib.document, version: lib.version });

    this.syncedAt = moment();
    this.createdAt = lib.createdAt;
    this.updatedAt = lib.updatedAt;
    this.deletedAt = lib.deletedAt;
  }
}
